import { Empty, Spin } from 'antd'
import Pagination from 'components/Pagination'
import {
  RowNumberData,
  TableStatusDataAlignment,
  Wrapper,
} from 'components/TableStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import ActionDropdown from 'modules/Users/Partials/UsersTable/ActionDropdown'
import UserStatus from 'modules/Users/Partials/UsersTable/UserStatus'
import ViewUserRoleDrawer from 'modules/Users/Partials/ViewUserRoleDrawer'
import { EmptyWrapper } from 'modules/Users/Style/style'
import React, { useState } from 'react'

const UsersTable = ({
  userList,
  userRole,
  setSortBy,
  loading,
  getSingleUserInfo,
  singleUserData,
  setAddUserDrawer,
  setUserId,
  updateUserStatus,
  deleteUser,
  setPageNum,
  getUserData,
  pageNum,
  updateLoading,
  cruds,
  inActiveTemplate,
  sendNotificationEmail,
  activeTemplate,
  ScrollRef,
}) => {
  const [viewUserDrawer, setViewUserDrawer] = useState(false)

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? '-'
  }

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter?.order ? sorter : '')
  }

  const onPageChange = num => {
    ScrollRef()
    setPageNum(num)
  }

  const columns = [
    {
      title: 'name',
      dataIndex: 'name',
      key: 'first_name',
      sorter: true,
      render: (_, rowData) => (
        <RowNumberData>
          {rowData?.first_name} {rowData?.last_name}
        </RowNumberData>
      ),
    },
    {
      title: 'user role',
      dataIndex: 'admin_role_id',
      key: 'admin_role_id',
      sorter: true,
      render: rowData => <RowNumberData>{getRoleName(rowData)}</RowNumberData>,
    },
    {
      title: 'email ID',
      dataIndex: 'email',
      key: 'email',
      render: rowData => rowData,
    },
    {
      title: 'Last Login',
      dataIndex: 'last_login_date',
      key: 'last_login_date',
      render: rowData => {
        if (!rowData) {
          return <RowNumberData>-</RowNumberData>
        }

        const formattedDate = new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }).format(new Date(rowData)).replace(/am|pm/i, match => match.toUpperCase())

        return <RowNumberData>{formattedDate}</RowNumberData>
      },
    },
    {
      title: 'status',
      dataIndex: 'status',
      key: 'status',

      render: (status, rowData) =>
        rowData?.is_active === true || rowData?.is_active === false ? (
          <TableStatusDataAlignment>
            {' '}
            <UserStatus status={rowData?.is_active} />{' '}
          </TableStatusDataAlignment>
        ) : (
          '-'
        ),
    },
    {
      title: 'Action',
      dataIndex: '_id',
      width: 150,
      render: (id, rowData) => (
        <ActionDropdown
          rowData={rowData}
          setViewUserDrawer={setViewUserDrawer}
          getSingleUserInfo={getSingleUserInfo}
          setAddUserDrawer={setAddUserDrawer}
          setUserId={setUserId}
          updateUserStatus={updateUserStatus}
          deleteUser={deleteUser}
          getUserData={getUserData}
          cruds={cruds}
          inActiveTemplate={inActiveTemplate}
          activeTemplate={activeTemplate}
          sendNotificationEmail={sendNotificationEmail}
        />
      ),
    },
  ].filter(item => !item?.hidden)
  return (
    <>
      <Wrapper>
        <StyledTable
          columns={columns}
          pagination={false}
          dataSource={userList?.list}
          onChange={onSorting}
          locale={{
            emptyText: (
              <EmptyWrapper center isSpin={loading}>
                {!loading ? <Empty description={'No user found!'} /> : <Spin />}
              </EmptyWrapper>
            ),
          }}
        />

        <Pagination
          onChange={onPageChange}
          totalPages={userList?.count}
          pageSize={10}
          current={pageNum}
        />
      </Wrapper>

      <ViewUserRoleDrawer
        viewUserDrawer={viewUserDrawer}
        setViewUserDrawer={setViewUserDrawer}
        singleUserData={singleUserData}
        getRoleName={getRoleName}
        updateLoading={updateLoading}
      />
    </>
  )
}

export default UsersTable
